import { render, staticRenderFns } from "./FoodClassList.vue?vue&type=template&id=1e645f78&scoped=true&"
import script from "./FoodClassList.vue?vue&type=script&lang=js&"
export * from "./FoodClassList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e645f78",
  null
  
)

export default component.exports